import { ConfigEntryFieldType, ConfigEntryType, ConfigFieldEntryType } from 'config/config';

export const DEFAULT_STANDARD_PROJECT_FIELDS: ConfigEntryType[] = [
  {
    entryCode: 'name',
    entryDescription: 'Name',
    entryType: ConfigFieldEntryType.STANDARD,
    entryValues: [],
    isActive: true,
    otherAttributes: {},
    referenceObject: {
      type: ConfigEntryFieldType.TEXT,
      label: 'Name',
      placeHolder: 'Add a name',
      isRequired: true,
    },
  },
  {
    entryCode: 'squareFeet',
    entryDescription: 'Square Feet',
    entryType: ConfigFieldEntryType.STANDARD,
    entryValues: [],
    isActive: true,
    otherAttributes: {},
    referenceObject: {
      type: ConfigEntryFieldType.TEXT,
      label: 'Square Feet',
      placeHolder: 'Square Feet',
      isRequired: false,
    },
  },
  {
    entryCode: 'address',
    entryDescription: 'Address',
    entryType: ConfigFieldEntryType.STANDARD,
    entryValues: [],
    isActive: true,
    otherAttributes: {},
    referenceObject: {
      type: ConfigEntryFieldType.TEXT,
      label: 'Address',
      placeHolder: 'Add address',
      isRequired: false,
    },
  },
  {
    entryCode: 'city',
    entryDescription: 'City',
    entryType: ConfigFieldEntryType.STANDARD,
    entryValues: [],
    isActive: true,
    otherAttributes: {},
    referenceObject: {
      type: ConfigEntryFieldType.TEXT,
      label: 'City',
      placeHolder: 'City',
      isRequired: false,
    },
  },
  {
    entryCode: 'state_code',
    entryDescription: 'State',
    entryType: ConfigFieldEntryType.STANDARD,
    entryValues: [],
    isActive: true,
    otherAttributes: {},
    referenceObject: {
      type: ConfigEntryFieldType.TEXT,
      label: 'State',
      placeHolder: 'State',
      isRequired: false,
    },
  },
  {
    entryCode: 'zip',
    entryDescription: 'Zip',
    entryType: ConfigFieldEntryType.STANDARD,
    entryValues: [],
    isActive: true,
    otherAttributes: {},
    referenceObject: {
      type: ConfigEntryFieldType.TEXT,
      label: 'Zip',
      placeHolder: 'Zip',
      isRequired: false,
    },
  },
  {
    entryCode: 'campus',
    entryDescription: 'Campus',
    entryType: ConfigFieldEntryType.STANDARD,
    entryValues: [],
    isActive: true,
    otherAttributes: {},
    referenceObject: {
      type: ConfigEntryFieldType.SELECT,
      configRefName: 'CAMPUSES',
      label: 'Campus',
      placeHolder: 'Select Campus',
    },
    targetMapperType: 'CONFIG',
  },
  {
    entryCode: 'projectRegion',
    entryDescription: 'Region',
    entryType: ConfigFieldEntryType.STANDARD,
    entryValues: [],
    isActive: true,
    otherAttributes: {},
    referenceObject: {
      type: ConfigEntryFieldType.SELECT,
      configRefName: 'REGIONS',
      label: 'Region',
      placeHolder: 'Select Region',
    },
    targetMapperType: 'CONFIG',
  },
  {
    entryCode: 'geography',
    entryDescription: 'Geography',
    entryType: ConfigFieldEntryType.STANDARD,
    entryValues: [],
    isActive: true,
    otherAttributes: {},
    referenceObject: {
      type: ConfigEntryFieldType.SELECT,
      configRefName: 'GEOGRAPHIES',
      label: 'Geography',
      placeHolder: 'Select Geography',
    },
    targetMapperType: 'CONFIG',
  },
  {
    entryCode: 'description',
    entryDescription: 'Description',
    entryType: ConfigFieldEntryType.STANDARD,
    entryValues: [],
    isActive: true,
    otherAttributes: {},
    referenceObject: {
      type: ConfigEntryFieldType.EDITOR,
      label: 'Description',
      placeHolder: 'Description',
      isRequired: false,
    },
  },
];
